module.exports = __webpack_public_path__ + "fonts/1898d52.otf";